export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1591377852/general/cflogo_black.png'
export const about =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1636442433/sushiwara/about_14_1.jpg'
export const contactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636670617/waradelta/footer.jpg'
export const hero =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636666537/waradelta/heroBg.jpg'
export const heroText =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636687624/waradelta/heroText.png'
export const logo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1634653295/ginger/logo_6.png'
export const locationMap =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1636442467/sushiwara/map_2_1.jpg'
export const mobileAbout =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671571/waradelta/mobileAbout.jpg'
export const mobileAbout2 =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1623953230/sushiami/mobileAbout2Update.jpg'
export const mobileContactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636672044/waradelta/mobileContact.jpg'
export const mobileHero =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671012/waradelta/mobileHero.jpg'
export const mobileLogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1635192815/ginger/mobileLogo.png'
export const mobileMap =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671133/waradelta/mobileMap.jpg'
export const mobileHeroText =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636670859/waradelta/mobileHeroText.png'
export const mobilePromotion =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671199/waradelta/mobilePromotion.jpg'
export const orderPickupButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636687059/waradelta/orderPickup.png'
export const orderDeliveryButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636687059/waradelta/orderDelivery.png'
export const promotions =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636670443/waradelta/promotions.jpg'
export const foodGallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636670501/waradelta/foodGallery.jpg'
export const mobileGallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671849/waradelta/mobileGallery.jpg'
export const promo1 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671316/waradelta/promo1.jpg'
export const promo2 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671317/waradelta/promo2.jpg'
export const promo3 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671316/waradelta/promo3.jpg'
export const gallery1 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671762/waradelta/gallery1.jpg'
export const gallery2 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671762/waradelta/gallery2.jpg'
export const gallery3 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1636671762/waradelta/gallery3.jpg'
export const doorDash =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1627344569/masquesolo/doorDash.png'
export const skipTheDishes =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1627344569/masquesolo/skipDishes.png'
export const uberEats =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1627344569/masquesolo/UberEats.png'
